var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"footer-wrapper"},[_c('div',[_c('footer-SNS'),_c('p',{staticClass:"footer-text"},[_vm._v("TOSHIHIRO YUASA | info@ToshihiroYuasa.jp")])],1),_c('footer-scroll')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }